
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import storage from '@/services/storage';

@Component
export default class S3Image extends Vue {
	@Prop({ type: String, required: true }) readonly s3FileKey!: string;

	filepath: any = null;

	@Watch('s3FileKey', { immediate: true })
	async getFile() {
		this.filepath = await storage.get(this.s3FileKey);
	}
}
